import React from 'react';

import { Intervenant, Participant } from 'icc/types/user';

export const ParticipantDetailsContext = React.createContext<Participant | undefined>(undefined);
export const IntervenantDetailsContext = React.createContext<Intervenant | undefined>(undefined);
